module.exports = __webpack_public_path__ + "static/img/refresh-cache-step2.f5f68a1f.png";